var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"examList"},[_c('exam-list')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }